import { render, staticRenderFns } from "./WelcomeBackgroundShield.vue?vue&type=template&id=65bd9c62&"
import script from "./WelcomeBackgroundShield.vue?vue&type=script&lang=js&"
export * from "./WelcomeBackgroundShield.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeBackgroundShield.vue?vue&type=style&index=0&id=65bd9c62&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports